<div class="d-flex flex-column gap-2">
  <app-member-search-input
    [formControl]="memberControl"
    [employerId]="employerId"
    [label]="label"
    [placeHolder]="placeHolder"
    [searchByNameOnly]="searchByNameOnly" />
  <app-pill
    *ngIf="selectedMember$ | async"
    [pillItem]="selectedMemberPillItem$ | async"
    [fontSize]="'0.875rem'"
    [padding]="'0.5rem 0.75rem'"
    [showXButton]="true"
    [disabled]="disabled"
    (clicked)="clearSelectedMember()" />
</div>
